module.exports = __webpack_public_path__ + "8c80587f137cff6e39d4318350af3d56.jpg";